/* eslint-disable no-console */
import React from 'react';
import TEMPLATE from './authTemplate';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  BASE_URL,
  CORPORATE,
  DASHBOARD_URL,
  INDIVIDUAL,
  SIGNIN_URL,
  SIGNUP_URL,
  GET_SME_USER_COUNTRY_LIST_TO_MIGRATE,
  UTM_CAMPAIGNING,
  NEWAUTHSCREEN,
  US,
  USER_SELECTED_COUNTRY_COOKIE_NAME,
  REFERRAL_CODE,
  STATEMENTS,
  HELP_CENTER_PUBLIC_PROFILE_FCNR_PARAM,
  HELP_CENTER_PUBLIC_PROFILE_PARAM
} from '../../../utils/constants';
import { showMessage } from '@Redux/actions/common-message';
import { change, Field, formValueSelector, reduxForm, reset, destroy } from 'redux-form';
import { resetPasswordRequest, getResetPasswordLink } from '@Redux/actions/authentication';
import {
  SocialLogins,
  GenerateField,
  CheckboxField,
  ModalFactory,
  CreateTicket,
  CommonButton,
  CaptchaMessage
} from '@Components';
import { connect } from 'react-redux';
import { API_URL, BUILD, SME_URL } from '../../../utils/config';
import { makeApiCall, getContentSchemaFromContentFul } from '@Redux/actions/common';
import { activateLoader, disableLoader, scrollToError } from '@Redux/actions/ui-trigger';
import { getPhoneValidationsByCountry } from '../../../redux/actions/otp-request/otp-request-action';
import Modal from '@material-ui/core/Modal';
import { Transition } from 'semantic-ui-react';
import {
  CaptchaContainer,
  Close,
  Content,
  LoaderImage,
  ModalContent,
  ModalWrapper
} from './Styles';
import SocialDisbleScreen from '../social-issue/Social';
import isEmpty from 'lodash/isEmpty';
import NewSignUpRedirectModal from './NewSignUpRedirectModal';
import PromoteApp from '../downloadAppPopUp/PromoteApp';
import { BLOCKED_RETAIL_SIGNUP_UTM_CAMPAIGNS, BUILD_VERSION } from '../../../redux/action-contants';
import {
  appDownloadFeature,
  checkParamInURL,
  getCookie,
  loadRecaptchaScript,
  setCookie,
  isIframeWindow
} from '../../../utils/library';
import { loadTurnstileScript } from '../../../utils/turnstile';
import {
  FLOW_TYPE_ONBOARDING,
  FLOW_TYPE_TROUBLE_LOGGING_IN,
  SIGN_UP_PAGE_VIEWED,
  TROUBLE_LOGGING_IN
} from '../../../utils/constants/eventsConstants';
import COLORS from '../../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import { getFlagValue, isFlagEnabled } from '@Redux/actions/flagsmith';
import { getUserLocation } from '../../../utils/geoLocation';
import { logEvent } from '../../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../../utils/events/eventsConstants';
import {
  CLOSE_NEW_ICON,
  FILLED_CHECKBOX_ICON,
  LOADER_ICON,
  NEW_INSTAREM_LOGO_ICON,
  RESET_BACK_ICON
} from '@Images';
import Captcha from '../../google-captcha/Captcha';
import withRouterV6 from '../../../components/common/withRouterV6';



let CURRENT_SCREEN = window.location.pathname.replace(`${BASE_URL}/`, '');
if (CURRENT_SCREEN.includes('invite')) {
  CURRENT_SCREEN = 'signup';
}
if (CURRENT_SCREEN.includes('forgot-password')) {
  CURRENT_SCREEN = 'forgotPassword';
}
if (CURRENT_SCREEN.includes('reset-password')) {
  CURRENT_SCREEN = 'resetPassword';
}
const FORM_ID = TEMPLATE[CURRENT_SCREEN]
  ? TEMPLATE[CURRENT_SCREEN].formID
  : TEMPLATE['signup'].formID;

class NewSignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      template: {},
      countries: [{ key: 1, value: 1, text: 'countries to be shown' }],
      term_conditions_error: false,
      country_code: 'SG',
      isResetLinkSent: false,
      modalOpen: false,
      country_code_error: false,
      mobile_code_error: false,
      mobCountryCodes: [],
      className: '',
      countryEnterCount: 0,
      mobileEnterCount: 0,
      userTyped: false,
      valueClicked: false,
      loggingIssueContent: null,
      facebookDisableData: null,
      showTroubleLoggingScreen: false,
      gaClientId: '',
      disableIndividualSignup: false,
      deepLinkValue: null,
      captchaToken: '',
      currentScreen: CURRENT_SCREEN,
      isContentLoading: this.isHelpCenterRedirect()
    };
    this.mobileFieldStyle = [{ width: '80px' }, { width: '235px' }];
    this.currentScreen = CURRENT_SCREEN;
    this.timeout = null;
  }
  isHelpCenterRedirect = () => {
    return (
      CURRENT_SCREEN === 'signin' &&
      (checkParamInURL(HELP_CENTER_PUBLIC_PROFILE_PARAM) === 'true' ||
        checkParamInURL(HELP_CENTER_PUBLIC_PROFILE_FCNR_PARAM) === 'true')
    );
  };

  handleCaptchaToken = (captchaToken) => {
    this.setState({ captchaToken });
    this.props.captchaHandler?.(captchaToken);
  };

  handleScroll = (e) => {
    const delay = (color, timer) => {
      setTimeout(() => {
        this.setState({ className: color });
      }, 10 * timer);
    };
    const colors = [
      'light-grey-1',
      'light-grey-2',
      'light-grey-3',
      'light-grey-4',
      'light-grey-5',
      'light-grey-6',
      'light-grey-7',
      'light-grey-8',
      'light-grey-9',
      'light-grey-10',
      'light-grey-11',
      'transparent'
    ];
    if (e.target.classList.contains('on-scroll') === false) {
      this.setState({ className: 'on-scroll' });
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.timeout = null;
        for (let colorIndex = 0; colorIndex < colors.length; colorIndex++) {
          const color = colors[colorIndex];
          delay(color, colorIndex);
        }
      }, 2000);
    }
  };

  handleDropdownClick = (e) => {
    return e.target.nodeName === 'LI' && this.setState({ valueClicked: true });
  };

  handleInputValueChange = (e) => {
    this.setGAClientID(e.target.value);
  };

  initializeFieldsBasedOnScreen = async (countriesData = []) => {
    const blockedRetailSignupCamp =
      (isFlagEnabled(BLOCKED_RETAIL_SIGNUP_UTM_CAMPAIGNS) &&
        getFlagValue(BLOCKED_RETAIL_SIGNUP_UTM_CAMPAIGNS)) ||
      [];
    this.setState({ isResetLinkSent: false });
    let init = { account_type: INDIVIDUAL };
    const {
      params: routerParams,
      location: { search }
    } = this.props;
    const params = new URLSearchParams(search);
    if (routerParams?.referred_by_referral_code) {
      this.setState({
        ...this.state,
        referred_by_referral_code: (init.referred_by_referral_code =
          routerParams.referred_by_referral_code)
      });
    }
    if (params.get('referral_code') || params.get('deep_link_sub1') === 'referral') {
      const referralCode = params.get('referral_code') || params.get('deep_link_value');
      this.setState({
        ...this.state,
        referred_by_referral_code: (init.referred_by_referral_code = referralCode)
      });
      setCookie(REFERRAL_CODE, referralCode);
    } else if (getCookie(REFERRAL_CODE)) {
      this.setState({
        ...this.state,
        referred_by_referral_code: (init.referred_by_referral_code = getCookie(REFERRAL_CODE))
      });
    }
    let isIndividualSignupDisabled = false;
    for (const item in blockedRetailSignupCamp) {
      if (blockedRetailSignupCamp[item] === params.get('utm_campaign')) {
        isIndividualSignupDisabled = true;
        break;
      }
    }
    let countryCode = await this.getCountryCode(countriesData);
    if (params.get('accountType') === CORPORATE || isIndividualSignupDisabled) {
      init.account_type = CORPORATE;
      countryCode = null;
    }
    init.country_code = countryCode;
    const signInInit = { email: '', password: '' };
    const forgotPasswordInit = { email: '' };
    const resetPasswordInit = {
      password: '',
      confirm_password: ''
    };
    this.props.initialize(
      this.currentScreen === 'signup'
        ? init
        : this.currentScreen === 'signin'
        ? signInInit
        : this.currentScreen === 'forgotPassword'
        ? forgotPasswordInit
        : this.currentScreen === 'resetPassword' && resetPasswordInit
    );
    this.setState({ ...this.state, template: TEMPLATE[this.currentScreen] });
    return isIndividualSignupDisabled;
  };

  /**
   *
   * @param {Array<Record<string, string>>} countriesData
   * @returns {string | null}
   *
   * get the country code from cookie, and if country code is no found or country code is EU, then get the code from lat and lng
   * and check if the code is present in countries dropdown. If yes, prefill the country. Otherwise, do not prefill
   */
  getCountryCode = async (countriesData) => {
    let countryCode = getCookie(USER_SELECTED_COUNTRY_COOKIE_NAME);
    if (!countryCode || countryCode === 'EU') {
      try {
        const { currentCountryCode } = await getUserLocation();
        if (currentCountryCode) {
          const code = countriesData?.find(
            (country) => country.key === currentCountryCode.toUpperCase()
          );
          if (code) {
            countryCode = currentCountryCode.toUpperCase();
          } else {
            countryCode = null;
          }
        }
      } catch (e) {
        // set countryCode null for EU's case
        countryCode = null;
        // eslint-disable-next-line
        console.log('location permission denied');
      }
    }
    return countryCode;
  };

  async componentDidMount() {
    const element = document.getElementById('auth_container_wrapper_scroll');
    element.addEventListener('scroll', this.handleScroll, true);
    document.addEventListener('keypress', this.disableReturn);
    document.addEventListener('click', this.handleDropdownClick);

    const input = document.querySelectorAll('[name=tracking_ga_cid]')[0];
    // Listen the event
    input?.addEventListener('change', this.handleInputValueChange);

    const {
      location: { search }
    } = this.props;
    const params = new URLSearchParams(search);
    const deepLinkValue = params.get('deep_link_value');
    this.setState({ deepLinkValue });
    let init = { account_type: INDIVIDUAL };
    if (params.get('accountType') === CORPORATE) {
      init.account_type = CORPORATE;
    }

    // call geoLocation api before initializing fields
    let countriesData = [];
    if (CURRENT_SCREEN !== 'forgotPassword' || CURRENT_SCREEN !== 'resetPassword') {
      this.props.isSignUp();
      countriesData = await this.getCountries();
    }

    // Load reCAPTCHA and Turnstile scripts only for signup screen
    if (this.currentScreen === 'signup') {
      try {
        await Promise.all([loadRecaptchaScript(), loadTurnstileScript()]);
      } catch (error) {
        console.error('Failed to load captcha scripts:', error);
      }
    }

    const isIndividualSignupDisabled = await this.initializeFieldsBasedOnScreen(countriesData);
    if (isIndividualSignupDisabled)
      this.setState({ disableIndividualSignup: isIndividualSignupDisabled });

    if (CURRENT_SCREEN === 'resetPassword') {
      this.getUserEmail();
    }
    if (this.currentScreen === 'signup') {
      let utmCampaigningCookie = getCookie(UTM_CAMPAIGNING);
      if (utmCampaigningCookie) utmCampaigningCookie = JSON.parse(utmCampaigningCookie);
      else utmCampaigningCookie = {};
      logEvent(
        SIGN_UP_PAGE_VIEWED,
        FLOW_TYPE_ONBOARDING,
        { ...utmCampaigningCookie },
        LOG_TYPE.CLEVER_TAP
      );
    }

    const loggingIssueContent = await getContentSchemaFromContentFul(
      'pageLoginTroubleshooting',
      'WEB_TROUBLESHOOT'
    );
    if (!isEmpty(loggingIssueContent)) {
      this.setState({
        loggingIssueContent: loggingIssueContent
      });
    }
    // This only clears the loader for help-center redirect URLs; no-op for plain /signin
    if (this.state.isContentLoading) {
      this.setState({ isContentLoading: false });
    }
    const facebookDisableData = await getContentSchemaFromContentFul(
      'componentMessageCentreItem',
      'FACEBOOK_DISABLED_POPUP'
    );
    if (!isEmpty(facebookDisableData)) {
      this.setState({
        facebookDisableData: facebookDisableData
      });
    }

    const isMobile = window.innerWidth < 700 ? true : false;
    isMobile &&
      !isIframeWindow() &&
      appDownloadFeature(CURRENT_SCREEN, init.account_type) &&
      this.showAppPromotionFlow(CURRENT_SCREEN);
  }

  getSmeCountryListToMigrate = () => {
    return (
      (isFlagEnabled(GET_SME_USER_COUNTRY_LIST_TO_MIGRATE) &&
        getFlagValue(GET_SME_USER_COUNTRY_LIST_TO_MIGRATE)) ||
      []
    );
  };

  async componentDidUpdate(prevProps, prevState) {
    if (localStorage.getItem('resetPassword') === 'true') {
      this.setState({ modalOpen: true });
      localStorage.removeItem('resetPassword');
    }
    const { country_code, account_type } = this.props;
    const isSmeMigrateCountryBusinessAccount =
      this.getSmeCountryListToMigrate().includes(country_code) &&
      ['CORPORATE'].includes(account_type);
    if (this.props.country_code !== prevProps.country_code && isSmeMigrateCountryBusinessAccount) {
      this.showNewSignupFlow();
    }
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.initializeFieldsBasedOnScreen(null, prevState.countries);
      const newScreen = this.props.location.pathname.replace(`${BASE_URL}/`, '');
      this.setState({ currentScreen: newScreen });
      if (newScreen.includes('signup')) {
        await Promise.all([loadRecaptchaScript(), loadTurnstileScript()]);
      }
    }
  }

  getUserEmail = async () => {
    let { params: routerParams, initialize, showMessage } = this.props;
    if (!routerParams || !routerParams.hash) return;
    try {
      let response = await makeApiCall({
        url: `${API_URL}/password/reset-email`,
        method: 'POST',
        data: { token: (this.hash = routerParams.hash) }
      });
      if (response && response.data && !response.data.success)
        return await showMessage(
          {
            text: [response.data.data ? response.data.data.message : 'Invalid URL']
          },
          'error'
        );
      initialize({ email: response.data.data.email });
    } catch (e) {
      let error = 'Invalid URL';
      if (e.response && e.response.data && e.response.data.data)
        error = e.response.data.data.message;
      return await showMessage({ text: [error] }, 'error');
    }
  };

  touchField = (field) => {
    const { touch, form } = this.props;
    touch(form, field);
  };

  unTouchField = (field) => {
    const { untouch, form } = this.props;
    untouch(form, field);
  };

  passwordReset = async () => {
    const { email, activateLoader, getResetPasswordLink, disableLoader, valid, touch, form } =
      this.props;
    if (!email && !valid) {
      touch(form, 'email');
    }
    if (email && valid) {
      activateLoader();
      try {
        let response = await getResetPasswordLink({
          email: email
        });
        if (response?.data?.data) {
          disableLoader();
          this.setState({ isResetLinkSent: true });
        }
      } catch (error) {
        disableLoader();
        // eslint-disable-next-line no-console
        console.log(error);
      }
    }
  };

  goback = () => {
    if (this.currentScreen === 'resetPassword') localStorage.setItem('resetPassword', true);
    this.props.dispatch(reset(FORM_ID));
    this.props.navigate(SIGNIN_URL, { replace: true });
  };

  showTroubleLoggingScreen = (isTroubleLoginClicked = false) => {
    this.setState({
      showTroubleLoggingScreen: !this.state.showTroubleLoggingScreen
    });
    if (isTroubleLoginClicked) {
      let ctData = {
        pageName: 'Login'
      };
      logEvent(TROUBLE_LOGGING_IN, FLOW_TYPE_TROUBLE_LOGGING_IN, ctData, LOG_TYPE.CLEVER_TAP);
    }
  };

  getMobCodes = async () => {
    const mobileCountryCodeURL = `${API_URL}/public/country/phone-code?concat_phone_country_code=true`;
    try {
      const response = await makeApiCall({
        method: 'get',
        url: mobileCountryCodeURL,
        withCredentials: true
      });
      if (response && response.data && response.data.success) {
        this.setState({
          mobCountryCodes: response.data.data
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  getCountries = async () => {
    let countriesData = [];
    try {
      let response = await makeApiCall({
        url: API_URL + '/public/remitter/countries/dropdown',
        method: 'get',
        params: {
          is_residence_activated: true
        }
      });
      if (!response)
        // eslint-disable-next-line no-console
        return console.error(response);
      if (response && response.data && response.data.success) {
        let data = response.data.data;
        countriesData = data;
        this.setState({ countries: data });
      }

      response = await makeApiCall({
        method: 'GET',
        url: `${API_URL}/public/country/default-configuration`
      });
      if (response && response.data && response.data.success) {
        let {
          data: { default_source_country: country_code }
        } = response.data;
        this.setState({ country_code });
      }
      return countriesData;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  };
  componentWillUnmount() {
    const element = document.getElementById('auth_container_wrapper_scroll');
    const input = document.querySelectorAll('[name=tracking_ga_cid]')[0];
    this.props.formUnmount();
    element?.removeEventListener('scroll', this.handleScroll);
    input?.removeEventListener('change', this.handleInputValueChange);
    document.removeEventListener('keypress', this.disableReturn);
    document.removeEventListener('click', this.handleDropdownClick);
  }
  submit = async (props) => {
    if (this.currentScreen === 'signup' && !this.props.is_term_conditions_accepted) {
      return await this.setState({ term_conditions_error: true });
    }
    const { pathname } = this.props.location;
    const isReferred = pathname.includes('invite');
    if (!isReferred && !props.referred_by_referral_code) delete props.referred_by_referral_code;
    await this.props.submitHandler(props);
  };
  resetSubmit = async (props) => {
    let response = await this.props.resetPasswordRequest({
      ...props,
      email: this.hash
    });
    if (response && response.data && response.data.success) {
      this.props.showMessage({
        text: [response.data.data.message],
        type: 'info'
      });
      this.props.initialize({ email: '', password: '' });
      return setTimeout(this.props.navigate, 1000, SIGNIN_URL);
    }
  };
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    let newPath = nextProps.location.pathname.replace(`${BASE_URL}/`, '');
    if (newPath.includes('invite')) {
      newPath = 'signup';
    }
    if (newPath.includes('forgot-password')) {
      newPath = 'forgotPassword';
    }
    if (newPath.includes('reset-password')) {
      newPath = 'resetPassword';
    }
    if (newPath) {
      CURRENT_SCREEN = newPath;
      this.currentScreen = CURRENT_SCREEN;
      this.setState({
        template: TEMPLATE[CURRENT_SCREEN] || TEMPLATE['signup']
      });
    }
    if (nextProps.location.pathname === SIGNUP_URL) {
      if (nextProps.is_user_authenticated) {
        this.props.navigate(DASHBOARD_URL);
      }
    }
    if (nextProps.mobile_country_code !== this.props.mobile_country_code) {
      if (nextProps.account_type === CORPORATE) {
        this.getValidation(nextProps.mobile_country_code);
      }
    }
    if (nextProps.account_type !== this.props.account_type) {
      if (nextProps.account_type === CORPORATE) this.getMobCodes();
    }
  };

  getValidation = async (mobCode) => {
    if (mobCode !== undefined && mobCode.length > 2) {
      const countryCode = mobCode?.split('_');
      countryCode && (await this.props.getPhoneValidationsByCountry(countryCode[1], true));
    }
  };
  setTCError = () => {
    this.setState({
      term_conditions_error: true,
      country_code_error: true,
      mobile_code_error: true
    });
  };

  disableReturn = async (e) => {
    const { countryEnterCount, mobileEnterCount, userTyped, valueClicked } = this.state;
    // to check whether user typing in dropdown
    if (
      e.key !== 'Enter' &&
      (e.target?.name === 'country_code' || e.target?.name === 'mobile_country_code')
    )
      await this.setState({ userTyped: true });
    // handling dropdown enter key press
    if (
      e.key === 'Enter' &&
      (e.target?.name === 'country_code' || e.target?.name === 'mobile_country_code')
    ) {
      if (e.target?.name === 'country_code') {
        // when user searches for a value and hits enter handling submit on second enter press
        if (countryEnterCount === 1 && userTyped)
          return this.setState({ countryEnterCount: 0, userTyped: false });
        // when user types a key word from search and clicks the value form dropdown
        if (countryEnterCount === 0 && userTyped && valueClicked)
          return this.setState({ countryEnterCount: 0, userTyped: false, valueClicked: false });
        // when user clicks a value from dropdown and presses enter
        if (!userTyped && valueClicked)
          return this.setState({ userTyped: false, valueClicked: false });
        this.setState({ countryEnterCount: 1 });
      }
      if (e.target?.name === 'mobile_country_code') {
        if (mobileEnterCount === 1 && userTyped)
          return this.setState({ mobileEnterCount: 0, userTyped: false });
        if (mobileEnterCount === 0 && userTyped && valueClicked)
          return this.setState({ mobileEnterCount: 0, userTyped: false, valueClicked: false });
        if (!userTyped && valueClicked)
          return this.setState({ userTyped: false, valueClicked: false });
        this.setState({ mobileEnterCount: 1 });
      }
      return e.preventDefault();
    }
    if (e.key === 'Enter') {
      e.preventDefault();
      document.getElementById(this.state.template.name + '-btn').click();
    }
  };

  showNewSignupFlow = async () =>
    await ModalFactory.builder(
      (onClose) => <NewSignUpRedirectModal onClose={onClose} />,
      'insta-modal center-modal',
      true
    );
  showAppPromotionFlow = async (screen) => {
    await ModalFactory.builder(
      (onClose) => (
        <PromoteApp onClose={onClose} screen={screen} deepLinkValue={this.state.deepLinkValue} />
      ),
      'insta-modal center-modal',
      true
    );
  };

  setGAClientID = (value) => {
    this.setState({
      gaClientId: value
    });
  };

  render() {
    const {
      heading,
      name,
      formStyle,
      fields,
      radioFields,
      checkbox,
      formID,
      showForgetPassword,
      otherOptions,
      isReset,
      buttonHeading,
      subHeading
    } = this.state.template;
    const {
      country_code,
      account_type,
      registered_business_name,
      mobile_country_code,
      mobile_number,
      formErrors,
      submitFailed
    } = this.props;
    const { isResetLinkSent, showTroubleLoggingScreen, loggingIssueContent, isContentLoading } =
      this.state;
    const buttonText = buttonHeading
      ? isResetLinkSent
        ? buttonHeading[1]
        : buttonHeading[0]
      : this.currentScreen === 'resetPassword'
      ? 'Reset'
      : heading;
    const buttonType = isReset ? 'button' : 'submit';
    const funcType = isReset
      ? isResetLinkSent
        ? this.goback
        : this.passwordReset
      : this.currentScreen === 'signup'
      ? this.setTCError
      : () => {
          return;
        };
    const isSmeMigrateCountryBusinessAccount =
      this.getSmeCountryListToMigrate().includes(country_code) &&
      ['CORPORATE'].includes(account_type);
    const publicHelpCenterLinks = loggingIssueContent?.publicHelpCenterLinks?.value;
    let isRedirectedPublicHelpCenterURL = false;
    let csManagerId, ticketSubjectLine;
    for (let key in publicHelpCenterLinks) {
      if (window.location.search.endsWith(publicHelpCenterLinks[key]?.publicUrl)) {
        isRedirectedPublicHelpCenterURL = true;
        csManagerId = publicHelpCenterLinks[key].zendeskcsManagerId;

        ticketSubjectLine = publicHelpCenterLinks[key].subject;
        break;
      }
    }
    const statements = this.state.loggingIssueContent?.fdSubjectArray?.value;

    const getCustomCountries = (countriesArray) => {
      if (account_type === CORPORATE) {
        return countriesArray.filter((country) => country?.key !== 'JP' && country?.key !== 'IN');
      } else {
        return countriesArray;
      }
    };

    if (isContentLoading) {
      return (
        <section
          id="auth_container_wrapper_scroll"
          className={`auth_container_wrapper ${this.state.className}${
            isIframeWindow() ? ' in-iframe' : ''
          }`}
        >
          <Transition visible={true} duration={300}>
            <LoaderImage src={LOADER_ICON} alt="loader" />
          </Transition>
        </section>
      );
    }

    return isRedirectedPublicHelpCenterURL ? (
      <CreateTicket
        className={this.state.className}
        currentScreen={this.currentScreen}
        csManagerId={csManagerId}
        ticketSubjectLine={ticketSubjectLine}
        loggingIssueContent={loggingIssueContent}
      />
    ) : (
      <section
        id="auth_container_wrapper_scroll"
        className={`auth_container_wrapper ${this.state.className} ${
          isIframeWindow() ? 'in-iframe' : ''
        }`}
      >
        <div className="tracking_ga_cid">
          <input type="hidden" name="tracking_ga_cid" value={this.state.gaClientId} />
        </div>
        {showTroubleLoggingScreen ? (
          <SocialDisbleScreen
            passwordReset={this.passwordReset}
            loggingIssueContent={loggingIssueContent}
            hideTroubleLoggingScreen={this.showTroubleLoggingScreen}
          />
        ) : (
          <form
            autoComplete="off"
            className="auth_container_form"
            id={formID}
            style={{ ...formStyle }}
            onSubmit={this.props.handleSubmit(
              this.currentScreen === 'resetPassword' ? this.resetSubmit : this.submit
            )}
          >
            {isReset && (
              <Link
                to={SIGNIN_URL}
                onClick={() => {
                  this.props.dispatch(reset(FORM_ID));
                }}
              >
                <img
                  src={RESET_BACK_ICON}
                  alt="go-back"
                  width="20px"
                  height="25px"
                  className="auth_container_form_goBack"
                />
              </Link>
            )}
            {!isIframeWindow() && (
              <img
                className="auth_container_form_instarem"
                src={NEW_INSTAREM_LOGO_ICON}
                alt="instarem-logo"
              />
            )}
            <h1
              style={{
                marginBottom: this.currentScreen === 'resetPassword' && '35px'
              }}
            >
              {heading}
            </h1>
            {name === 'SIGN_UP' && (
              <p className="margin-bottom-50">
                {`${NEWAUTHSCREEN.alreadySignedUpText} `}
                <Link
                  to={SIGNIN_URL}
                  onClick={() => {
                    this.props.dispatch(reset(FORM_ID));
                    this.props.dispatch(destroy(FORM_ID));
                  }}
                >
                  <CommonButton
                    text={NEWAUTHSCREEN.logInHereText}
                    type="link"
                    color={COLORS.darkBlue}
                    fontFamily={FONT_FAMILY.hellix.bold}
                  />
                </Link>
              </p>
            )}
            {name === 'SIGN_IN' && (
              <p className={'margin-bottom-70'}>
                {`${NEWAUTHSCREEN.newToInstarem} `}
                <Link
                  to={SIGNUP_URL}
                  onClick={() => {
                    this.props.dispatch(reset(FORM_ID));
                    this.props.dispatch(destroy(FORM_ID));
                  }}
                >
                  <CommonButton
                    text={NEWAUTHSCREEN.signUpHereText}
                    type="link"
                    fontFamily={FONT_FAMILY.hellix.bold}
                  />
                </Link>
              </p>
            )}
            {radioFields && (
              <div className="auth_container_form_radio">
                {radioFields.map((radioField) => {
                  return (
                    <GenerateField
                      fieldConfig={{
                        ...radioField,
                        onClick: () => {
                          this.props.dispatch(reset(formID));
                          if (radioField.value === CORPORATE)
                            this.props.dispatch(change(formID, 'country_code', null));
                          this.setState({
                            mobile_code_error: false,
                            country_code_error: false
                          });
                        }
                      }}
                      fieldValue={{
                        ...this.props
                      }}
                      key={radioField.value}
                      disabledRadioField={
                        radioField.value === INDIVIDUAL && this.state.disableIndividualSignup
                      }
                    />
                  );
                })}
              </div>
            )}
            {isReset && (
              <p className="margin-bottom-70 width-325" id="reset-text">
                {isResetLinkSent ? subHeading.heading[1] : subHeading.heading[0]}
              </p>
            )}
            {fields &&
              fields.map((field, idx) => {
                if (field.fields && field.fields.length !== 0) {
                  return (
                    <div className="auth_container_form_mobile" key={idx}>
                      {field.fields.map((nestedField, index) => {
                        return (
                          <GenerateField
                            key={nestedField.name}
                            onChange={this.handleChange}
                            formSubmitted={submitFailed}
                            fieldConfig={{
                              ...nestedField,
                              customStyle: this.mobileFieldStyle[index]
                            }}
                            fieldValue={{
                              ...this.props,
                              countries: field.dropdown && this.state.countries,
                              mobCountryCodes: this.state.mobCountryCodes,
                              mobile_code_error: this.state.mobile_code_error,
                              country_code_error: this.state.country_code_error
                            }}
                          />
                        );
                      })}
                    </div>
                  );
                }
                return (
                  !isResetLinkSent && (
                    <div key={field.name}>
                      <GenerateField
                        key={field.name}
                        fieldConfig={{
                          ...field,
                          autoComplete: 'off'
                        }}
                        onChange={this.handleChange}
                        formSubmitted={submitFailed}
                        currentScreen={this.currentScreen}
                        fieldValue={{
                          ...this.props,
                          countries: field.dropdown && getCustomCountries(this.state.countries),
                          mobile_code_error: this.state.mobile_code_error,
                          country_code_error: this.state.country_code_error
                        }}
                        referralCode={this.state.referred_by_referral_code}
                      />
                      {isSmeMigrateCountryBusinessAccount &&
                        ['country_code'].includes(field.name) && (
                          <div
                            id={'new_signup_flow_msg'}
                            style={{ marginBottom: '30px', fontSize: '12px', lineHeight: '16px' }}
                          >
                            {' We have upgraded our onboarding experience. '}
                            <br />
                            {' Visit '}
                            <a
                              id="new_signup_flow_link"
                              style={{ color: '#FE0095' }}
                              href={SME_URL}
                            >
                              {SME_URL}
                            </a>{' '}
                            {' to register for an '}
                            <br /> {' account with us! '}
                          </div>
                        )}
                    </div>
                  )
                );
              })}
            {checkbox && (
              <div>
                <Field
                  name="is_term_conditions_accepted"
                  checked={this.props.is_term_conditions_accepted}
                  component={CheckboxField}
                  checkboxTextFontSize="12"
                  checkboxTextLineHeight="16"
                  broderBorder={true}
                  customImage={FILLED_CHECKBOX_ICON}
                  showDisclaimer={true}
                  width={24}
                  height={24}
                  handleChange={(value) => {
                    this.props.dispatch(change(formID, 'is_term_conditions_accepted', value));
                  }}
                  checkboxContent={
                    <>
                      {country_code === 'ID'
                        ? statements?.tncConfirmation || STATEMENTS.tncConfirmation
                        : 'By signing up, you agree to our '}
                      <a
                        id="all-policies-1"
                        style={{
                          color: COLORS.darkBlue,
                          fontFamily: FONT_FAMILY.hellix.regular
                        }}
                        href="/terms-policies/"
                        target="_blank"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        Terms and Conditions
                      </a>
                      <span>
                        {country_code === US ? ', ' : country_code === 'ID' ? '' : ' and '}
                      </span>
                      {country_code !== 'ID' && (
                        <a
                          id="all-policies-2"
                          style={{
                            color: COLORS.darkBlue,
                            fontFamily: FONT_FAMILY.hellix.regular
                          }}
                          href="/terms-policies/privacy-notice/ "
                          target="_blank"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          Privacy Policy
                        </a>
                      )}
                      {country_code === US ? (
                        <>
                          , and the{' '}
                          <a
                            id="all-policies-2"
                            style={{ color: COLORS.darkBlue }}
                            href="https://www.cfsb.com/privacy/"
                            target="_blank"
                            rel="noreferrer"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            CFSB Privacy Notice.
                          </a>
                        </>
                      ) : (
                        <>.</>
                      )}
                    </>
                  }
                />
                {this.state.term_conditions_error && !this.props.is_term_conditions_accepted && (
                  <p className="T-C_error width-325">
                    You need to review and accept our T&C to proceed
                  </p>
                )}
              </div>
            )}
            {checkbox && (
              <div style={{ marginBottom: '24px' }}>
                <Field
                  name="is_promotion_subscription"
                  checked={this.props.is_promotion_subscription}
                  component={CheckboxField}
                  checkboxTextFontSize="12"
                  checkboxTextLineHeight="18"
                  broderBorder={true}
                  showDisclaimer={true}
                  checkboxTextMarginTop="16"
                  customImage={FILLED_CHECKBOX_ICON}
                  width={24}
                  height={24}
                  handleChange={(value) => {
                    this.props.dispatch(change(formID, 'is_promotion_subscription', value));
                  }}
                  checkboxContent={
                    <span className="consentMsg">
                      {country_code === 'ID' ? (
                        <>
                          {statements?.privacyStatement || STATEMENTS.privacyStatement}
                          <a
                            id="all-policies-2"
                            style={{ color: COLORS.darkBlue }}
                            href="/terms-policies/privacy-notice/ "
                            target="_blank"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            Privacy Policy
                          </a>
                        </>
                      ) : (
                        `I allow Instarem to email and message me relevant offers and promotions based
                      on my Instarem activity`
                      )}
                    </span>
                  }
                />
              </div>
            )}
            {showForgetPassword && loggingIssueContent ? (
              <div
                className="troubleLoggingLink"
                onClick={() => this.showTroubleLoggingScreen(true)}
              >
                <CommonButton text={NEWAUTHSCREEN.troubleLoggingText} type="link" />
              </div>
            ) : this.currentScreen === 'signin' ? (
              <div className="troubleLoggingLink" />
            ) : null}
            {this.currentScreen === 'signup' && <CaptchaMessage marginTop={0} marginBottom={16} />}
            {this.currentScreen === 'signup' ? (
              <CaptchaContainer>
                <Captcha
                  handleChildCaptchaToken={this.handleCaptchaToken}
                  shouldShowCaptcha={this.props.shouldShowCaptcha}
                />
              </CaptchaContainer>
            ) : null}
            <CommonButton
              id={name + '-btn'}
              margin={
                this.currentScreen === 'resetPassword'
                  ? '70px 0 0'
                  : this.currentScreen === 'forgotPassword' && '70px 0 130px'
              }
              width={324}
              type={buttonType}
              onClick={funcType}
              text={buttonText}
              disabled={isSmeMigrateCountryBusinessAccount}
            />
            {otherOptions && !isSmeMigrateCountryBusinessAccount && (
              <>
                <div className="auth_container_form_option">
                  <h6>Or {heading?.toLowerCase()} with</h6>
                </div>
                <SocialLogins
                  txtSocialContent={
                    'If you have a referral code, please do not forget to enter it in the space below'
                  }
                  txtBtnCancel={'Proceed to sign up'}
                  txtBtnConfirm={'Add a referral code'}
                  highlightReferral={this.highlightReferral}
                  valueReferralCode={
                    formErrors?.referred_by_referral_code
                      ? formErrors.referred_by_referral_code
                      : this.props.referred_by_referral_code
                  }
                  accountType={account_type}
                  countryCode={country_code}
                  registered_business_name={registered_business_name}
                  mobile_number={mobile_number}
                  mobile_country_code={mobile_country_code}
                  captureReferralCode={this.socialReferralCode}
                  isSignUp={this.currentScreen === 'signup'}
                  isSignupApi={this.state.currentScreen === 'signup'}
                  is_term_conditions_accepted={this.props.is_term_conditions_accepted}
                  isIndividual={account_type === INDIVIDUAL}
                  touchField={this.touchField}
                  setTCError={this.setTCError}
                  unTouchField={this.unTouchField}
                  deepLinkValue={this.state.deepLinkValue}
                />
              </>
            )}
            {BUILD !== 'prod' ? (
              <div id="build-version">Build version v {getFlagValue(BUILD_VERSION)}</div>
            ) : null}
          </form>
        )}
        <Modal
          open={this.state.modalOpen}
          onClose={() => this.setState({ modalOpen: !this.state.modalOpen })}
        >
          <ModalWrapper>
            <ModalContent>
              <Close>
                <img
                  src={CLOSE_NEW_ICON}
                  alt="close"
                  height="20px"
                  width="20px"
                  onClick={() => this.setState({ modalOpen: false })}
                />
              </Close>
              <Content>
                <p>{NEWAUTHSCREEN.passwordResetText}</p>
                <p>{NEWAUTHSCREEN.useNewPassowrdText}</p>
                <CommonButton
                  width={324}
                  onClick={() => this.setState({ modalOpen: false })}
                  id={name + '-btn'}
                  text="Got it"
                />
              </Content>
            </ModalContent>
          </ModalWrapper>
        </Modal>
      </section>
    );
  }
}

let createReduxForm = reduxForm({
  form: FORM_ID,
  onSubmitFail: scrollToError,
  destroyOnUnmount: true
});
const ReduxFormNewSignUp = createReduxForm(NewSignUp);
const formValues = formValueSelector(FORM_ID);

function mapStateToProps(reduxState) {
  const {
    rootReducer: {
      userSessionReducer: { is_user_authenticated },
      mobileValidationReducer,
      uiTriggerState: { device }
    },
    form
  } = reduxState;

  let formErrors = null;
  if (form && form.newSignUp && form.newSignUp.syncErrors) {
    formErrors = form.newSignUp.syncErrors;
  }

  let {
    is_term_conditions_accepted,
    referred_by_referral_code,
    is_promotion_subscription,
    country_code,
    account_type,
    password,
    registered_business_name,
    mobile_number,
    mobile_country_code,
    email
  } = formValues(
    reduxState,
    'is_term_conditions_accepted',
    'is_promotion_subscription',
    'referred_by_referral_code',
    'country_code',
    'account_type',
    'password',
    'registered_business_name',
    'mobile_number',
    'mobile_country_code',
    'email'
  );

  return {
    is_user_authenticated,
    formErrors,
    country_code,
    is_term_conditions_accepted,
    referred_by_referral_code,
    is_promotion_subscription,
    account_type,
    password,
    registered_business_name,
    mobile_number,
    mobile_country_code,
    mobileValidationReducer,
    email,
    device
  };
}

NewSignUp.propTypes = {
  navigate: PropTypes.func,
  initialize: PropTypes.func,
  showMessage: PropTypes.func,
  valid: PropTypes.bool,
  touch: PropTypes.func,
  form: PropTypes.any,
  formUnmount: PropTypes.func,
  is_term_conditions_accepted: PropTypes.bool,
  referred_by_referral_code: PropTypes.string,
  is_promotion_subscription: PropTypes.bool,
  submitHandler: PropTypes.func,
  resetPasswordRequest: PropTypes.func,
  is_user_authenticated: PropTypes.bool,
  mobile_country_code: PropTypes.string,
  account_type: PropTypes.string,
  getPhoneValidationsByCountry: PropTypes.func,
  country_code: PropTypes.string,
  registered_business_name: PropTypes.string,
  formErrors: PropTypes.any,
  submitFailed: PropTypes.any,
  dispatch: PropTypes.func,
  location: PropTypes.object,
  activateLoader: PropTypes.func,
  disableLoader: PropTypes.func,
  getResetPasswordLink: PropTypes.func,
  mobile_number: PropTypes.any,
  handleSubmit: PropTypes.func,
  isSignUp: PropTypes.func,
  email: PropTypes.string,
  untouch: PropTypes.func,
  device: PropTypes.string,
  captchaHandler: PropTypes.func,
  shouldShowCaptcha: PropTypes.bool,
  params: PropTypes.object
};

export default withRouterV6(
  connect(mapStateToProps, {
    getResetPasswordLink,
    activateLoader,
    disableLoader,
    getPhoneValidationsByCountry,
    resetPasswordRequest,
    showMessage
  })(ReduxFormNewSignUp)
);
